/** @format */
import { h } from 'vue';
import { dynamicLoadByName } from '@/utils';

const draggable = shallowRef<any>(h('div'));

const loaded = ref(false);

const loadVueDraggable = async () => {
	if (!window['vuedraggable']) {
		await dynamicLoadByName('vuedraggable');
	}
	draggable.value = window['vuedraggable'];
	loaded.value = true;
};

const getDraggable = computed(() => {
	if (!loaded.value) {
		loadVueDraggable();
	}
	return draggable.value;
});

export default getDraggable;
